var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 31.2H16V16h4.5c.6 0 1-.4 1-1s-.4-1-1-1H15c-.6 0-1 .4-1 1v17.2c0 .6.4 1 1 1h5.5c.6 0 1-.4 1-1s-.4-1-1-1",
    className: "ico_pri"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m33.7 22.9-5.5-5.5c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3.8 3.8H21c-.6 0-1 .4-1 1s.4 1 1 1h9.6l-3.8 3.8c-.4.4-.4 1 0 1.4s1 .4 1.4 0l5.5-5.5c.4-.4.4-1 0-1.4",
    className: "ico_pri"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogout);
export default __webpack_public_path__ + "static/media/IcoLogout.decb38b2122efeea5f1fc7342db8d7e5.svg";
export { ForwardRef as ReactComponent };